<template>
  <v-card class="overflow-hidden">
    <v-app-bar class="my-background" height="60px">
      <!-- Logo empresa -->
      <v-img
        alt="Loginsa Logo"
        class="shrink ml-4 mt-2"
        :src="require('../assets/Logins@.svg')"
        width="150px"
      />
      <!-- boton de cambio de tema  -->
      <v-spacer></v-spacer>
      <!-- <v-btn
        class="orange--text"
        fab
        small
        v-model="valor"
        @click="
          valor = !valor;
          changeTheme();
        "
      >
        <v-icon>mdi-invert-colors </v-icon>
      </v-btn> -->
      <template v-slot:extension>
        <v-tabs align-with-title>
          <v-tab class="orange--text" to="/" style="align-content: center"
            ><v-icon class="orange--text">mdi-home</v-icon
            ><strong style="margin-top: 2%">&nbsp;Inicio</strong></v-tab
          >
          <!-- <v-tab class="orange--text" to="/empresas"><v-icon
                class="orange--text">mdi-magnify</v-icon><strong>Seguimiento de
                Orden</strong></v-tab> -->
          <!-- <v-tab
            class="orange--text"
            to="/"
            style="align-content: center"
            @click="irNewCliente"
            ><v-icon class="orange--text">mdi-account-plus</v-icon
            ><strong style="margin-top: 2%">&nbsp;Nuevo Cliente</strong></v-tab
          > -->
          <!-- <v-tab class="orange--text" to="/empresas"><v-icon
                class="orange--text">mdi-magnify</v-icon><strong>Seguimiento de
                Orden</strong></v-tab> -->
        </v-tabs>
      </template>
    </v-app-bar>
  </v-card>
</template>
<script>
import { mapMutations } from "vuex";
//import { router } from "@/router";
export default {
  data() {
    return {
      valor: true,
      width: null,
      height: null,
    };
  },
  mounted() {
    this.height = window.innerHeight;
    this.width = window.innerWidth;
  },
  methods: {
    ...mapMutations(["setTheme"]),
    changeTheme() {
      if (this.valor == true) {
        this.setTheme("light");
      } else {
        this.setTheme("dark");
      }
    },
    onResize() {
      this.height = window.innerHeight;
      this.width = window.innerWidth;
    },
    goToContainer() {
      this.$router.push({ name: "ayuda" });
    },
    irNewCliente() {
      this.$router.push({ name: "newCliente" });
    },
  },
};
</script>
